<template>
  <div class="sale animated animatedFadeInUp fadeInUp">
    <div class="sale__inner">
      <div class="mediana">
        <div class="mediana__item">
          <div class="mediana__sub">
            <div class="mediana__title">Медиана выкупов</div>
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.5 21H0.5V1" stroke="#C5C8CE" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                d="M12.8682 14.5234C13.0502 15.5234 13.3262 18.0004 16.0002 18.0004"
                stroke="#C5C8CE" stroke-width="0.8" stroke-linecap="round"
                stroke-linejoin="round"/>
              <path
                d="M3 18C4.447 18 5.688 16.965 5.947 15.54L7.143 8.96899C7.462 7.20999 9.523 6.41599 10.94 7.48199"
                stroke="#C5C8CE" stroke-width="0.8" stroke-linecap="round"
                stroke-linejoin="round"/>
              <path
                d="M8 18C9.447 18 10.688 16.965 10.947 15.54L12.143 8.96902C12.616 6.35702 16.383 6.35602 16.857 8.96902L18.053 15.54C18.312 16.965 19.553 18 21 18"
                stroke="#C5C8CE" stroke-width="0.8" stroke-linecap="round"
                stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="mediana__count" ref="medianaCount"></div>
          <div ref="medianaMoney"></div>
        </div>
      </div>
      <div class="mediana">
        <div class="mediana__item">
          <div class="mediana__sub">
            <div class="mediana__title">Сумма выкупов</div>
            <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.616 1H0.541992L11.2497 10.5L0.541992 20H16.616" stroke="#C5C8CE" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="mediana__count" ref="deviceCount"></div>
          <div ref="moneySum"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: 'TheSummary',
    watch: {
      elasticInfo(data) {
        if(data.aggregations.MoneySum.value !== undefined) {
          this.$refs.moneySum.innerText = this.moneySum + ' ₸'
        }

        if(data.aggregations.DeviceCount.value !== undefined) {
          this.$refs.deviceCount.innerText = this.deviceCount + ' шт.'
        }

        if(data.aggregations.MedianaCount.values['50.0'] !== undefined) {
          this.$refs.medianaCount.innerText = this.medianaCount + ' шт.'
        }

        if(data.aggregations.MedianaMoney.values['50.0'] !== undefined) {
          this.$refs.medianaMoney.innerText = this.medianaMoney + ' ₸'
        }
      }
    },
    computed: {
      ...mapState(['elasticInfo']),
      deviceCount() {
        let moneySum;
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          moneySum = this.elasticInfo.aggregations.DeviceCount.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else if (this.elasticInfo.aggregations.DeviceCount.value === 0) {
          moneySum = '--';
        }
        return moneySum;
      },
      moneySum() {
        let moneySum;
        if(this.elasticInfo.aggregations.MoneySum.value > 0) {
          moneySum = this.elasticInfo.aggregations.MoneySum.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else if (this.elasticInfo.aggregations.MoneySum.value === 0) {
          moneySum  = '--';
        }
        return moneySum;
      },

      medianaCount() {
        let moneySum;
        if(this.elasticInfo.aggregations.MedianaCount.values['50.0'] > 0) {
          moneySum = this.elasticInfo.aggregations.MedianaCount.values['50.0']
        } else if (this.elasticInfo.aggregations.MedianaCount.values['50.0'] === 0) {
          moneySum = 0;
        } else {
          moneySum = '--';
        }
        return moneySum;
      },

      medianaMoney() {
        let moneySum;
        if(this.elasticInfo.aggregations.MedianaMoney.values['50.0'] > 0) {
          moneySum = this.elasticInfo.aggregations.MedianaMoney.values['50.0']
        } else if (this.elasticInfo.aggregations.MedianaMoney.values['50.0'] === 0) {
          moneySum = 0;
        } else {
          moneySum = '--';
        }
        return moneySum;
      },
    },
    methods: {
      formatPrice(value) {
        let val = (value / 1);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    }
  };
</script>

<link rel="stylesheet" href="https://use.typekit.net/pyd5qbd.css">

<style>
  @font-face {
    font-family: noto-sans,sans-serif;
    font-weight: 400;
    font-style: normal;
  }
</style>
